import {
  Box,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';

import ContentLoader from '@components/ContentLoader';
import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';

import type { Profile } from '@models/session';

import { useGetUserNotificationPreferences } from 'generated/notification.generated';

import UserNotificationPreference from './UserNotificationPreference';

interface NotificationsProps {
  user?: Profile;
}

function NotificationSettings({ user }: NotificationsProps) {
  const { data, loading } = useGetUserNotificationPreferences({
    variables: {
      input: {
        user_id: user?.user_id ?? '',
      },
    },
    skip: !user?.user_id,
  });

  const grouped = _.groupBy(
    data?.getUserNotificationPreferences,
    ({ category }) => category
  );

  return (
    <Box>
      <ContentLoader loading={loading}>
        {Object.keys(grouped).map((category) => {
          const settings = grouped[category];
          return (
            <React.Fragment key={category}>
              <Typography variant="overline">{category}</Typography>
              <Card>
                <CardContent>
                  <List disablePadding>
                    {settings.map(({ name, description, preference }) => (
                      <ListItem
                        disableGutters
                        disablePadding
                        key={preference.user_id}
                        sx={{ minHeight: 0, py: 0 }}
                      >
                        <ListItemText
                          primary={name}
                          secondary={description}
                          primaryTypographyProps={{ variant: 'body2' }}
                        />
                        <UserNotificationPreference
                          {...preference}
                          enabled={preference.email_enabled}
                        />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </React.Fragment>
          );
        })}
      </ContentLoader>
    </Box>
  );
}

export default withErrorBoundary(NotificationSettings, {
  FallbackComponent: ErrorBoundaryFallback,
});
